var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1032 19.0102C16.9009 18.0894 18.3367 16.5905 19.1794 14.7547C20.0221 12.919 20.2227 10.8532 19.7491 8.88958C19.2754 6.92599 18.155 5.17881 16.568 3.92915C14.9811 2.67949 13.0199 2 11 2",
    stroke: "#009EFF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.028 10.2906C1.90176 11.8874 2.20393 13.4889 2.90333 14.9299C3.60272 16.3708 4.674 17.599 6.00658 18.4877C7.33916 19.3764 8.88477 19.8933 10.4839 19.9852C12.0829 20.077 13.6776 19.7405 15.1032 19.0102",
    stroke: "#007CC8",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90002 3.58466C4.79627 4.34382 3.87592 5.33981 3.2061 6.49996C2.53629 7.66011 2.1339 8.95516 2.02832 10.2906",
    stroke: "#007CC8",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 2C9.17844 2 7.40001 2.55257 5.89941 3.58469",
    stroke: "#009EFF",
    strokeWidth: 3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/Donut.7362d2795824a0fa5850f3835db8f5a2.svg";
export { ForwardRef as ReactComponent };